import React from 'react'
import styled, { css } from 'styled-components'

const width = '152'
const height = '152'
const viewBox = '0 0 152 152'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <defs key="key-0">
      <filter
        id="s-9c5f7077ba-a"
        width="218.2%"
        height="218.2%"
        x="-59.1%"
        y="-56.8%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="17"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0.25691977 0 0 0 0 0.296276739 0 0 0 0 0.367479804 0 0 0 0.149343297 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>,
    <g
      fill="#FFF"
      fillRule="evenodd"
      filter="url(#s-9c5f7077ba-a)"
      transform="translate(32 30)"
      key="key-1"
    >
      <path
        fillRule="nonzero"
        d="M43.932.248C19.818.248.247 19.85.247 44.006s19.57 43.758 43.685 43.758c24.114 0 43.684-19.603 43.684-43.758S68.046.248 43.932.248zm0 78.765c-19.265 0-34.948-15.71-34.948-35.007 0-19.298 15.683-35.007 34.948-35.007s34.947 15.71 34.947 35.007c0 19.297-15.682 35.007-34.947 35.007z"
        opacity=".8"
      />
      <path d="M37.196 58.931l19.866-14.925-19.866-14.925z" />
    </g>
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconYoutubePlay'
})
